import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Backups() {
  const [lista, setLista] = useState([]);
  const [reg, setReg] = useState(null);
  const [rodando, setRodando] = useState(false);

  const load = async () => {
    const [b, r] = await Promise.all([
      api.get("/admin/backup/listar"),
      api.get("/admin/banco-regularizacao"),
    ]);
    setLista(b.data); setReg(r.data);
  };

  useEffect(() => { load(); }, []);

  const trigger = async () => {
    setRodando(true);
    try {
      const r = await api.post("/admin/backup/executar");
      toast.success(`Backup criado · ${r.data.tamanho_kb} KB`);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setRodando(false); }
  };

  const baixar = async (nome) => {
    const token = localStorage.getItem("token");
    const r = await fetch(`${API}/api/admin/backup/download/${nome}`,
      { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob); a.download = nome; a.click(); URL.revokeObjectURL(a.href);
  };

  return (
    <div className="p-8 max-w-6xl">
      <div className="mb-6">
        <div className="label-cap">Master · Infra</div>
        <h1 className="font-heading font-extrabold text-3xl tracking-tighter mt-1">Backups & Banco de Regularização</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-4 mb-6">
        {/* Backups */}
        <div className="border border-border bg-white p-5">
          <div className="flex items-center justify-between mb-3">
            <div>
              <div className="label-cap">Backup Automático</div>
              <p className="text-xs text-muted-foreground mt-1">Cron diário às 04:00 BRT · retenção 30 dias</p>
            </div>
            <Button onClick={trigger} disabled={rodando} className="btn-sharp brand-bg text-white" data-testid="bk-trigger">
              {rodando ? "Rodando…" : "Executar agora"}
            </Button>
          </div>
          <div className="border-t border-border pt-3 max-h-[420px] overflow-y-auto">
            {lista.length === 0 && <div className="text-xs text-muted-foreground py-4">Nenhum backup ainda</div>}
            {lista.map(b => (
              <div key={b.nome} className="flex items-center justify-between py-2 border-b border-border last:border-0 text-xs"
                data-testid={`bk-${b.nome}`}>
                <div>
                  <div className="font-mono">{b.nome}</div>
                  <div className="text-muted-foreground">{new Date(b.criado_em).toLocaleString("pt-BR")} · {b.tamanho_kb} KB</div>
                </div>
                <Button onClick={() => baixar(b.nome)} size="sm" variant="outline" className="btn-sharp h-7 text-[10px]"
                  data-testid={`bk-dl-${b.nome}`}>Baixar</Button>
              </div>
            ))}
          </div>
        </div>

        {/* Banco de Regularização MEI */}
        <div className="border border-border bg-white p-5">
          <div className="label-cap">Banco de Oportunidades MEI</div>
          <p className="text-xs text-muted-foreground mt-1 mb-3">
            Montadores que declararam interesse em regularizar CNPJ ou abrir MEI. Para parcerias contábeis futuras.
          </p>
          {reg && (
            <>
              <div className="grid grid-cols-3 gap-2 mb-3">
                <Stat label="Querem regularizar" v={reg.resumo?.sim || 0} color="text-[#00A859]" />
                <Stat label="Talvez no futuro" v={reg.resumo?.talvez || 0} color="text-[#FFCC00]" />
                <Stat label="Sem interesse" v={reg.resumo?.nao || 0} color="text-muted-foreground" />
              </div>
              <div className="border-t border-border pt-3 max-h-[300px] overflow-y-auto">
                {reg.registros.length === 0 && <div className="text-xs text-muted-foreground py-2">Sem registros</div>}
                {reg.registros.map(r => (
                  <div key={r.montador_id} className="text-xs border-b border-border py-2 last:border-0">
                    <div className="font-medium">{r.nome || "—"}</div>
                    <div className="text-muted-foreground">{r.cidade || "—"}/{r.estado || "—"} · {r.email}</div>
                    <div className="text-[10px]">{r.possui_cnpj} · interesse: <strong>{r.interesse_regularizacao}</strong></div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function Stat({ label, v, color }) {
  return (
    <div>
      <div className="label-cap text-[9px]">{label}</div>
      <div className={`font-heading font-extrabold text-2xl ${color}`}>{v}</div>
    </div>
  );
}
